import React, { useState } from 'react'
import { observer } from 'mobx-react-lite'
import { Button } from 'common/Button'
import { Icon } from 'common/Icon'
import { symbolGradientMap, tokenToIconMap } from 'config/chainsMap'
import { getPolygonNetworks } from 'config/networks'
import { NetworkSelectorDialog } from './components/NetworkSelectorDialog'
import { useStore } from 'lib/store'
import { Network } from '@nsfw-app/crypto'
import { useHideBodyScrollbar } from 'hooks/useHideBodyScrollbar'
import { useWallets } from '@privy-io/react-auth'

const _NetworkSelector: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [isMobileOpen, setIsMobileOpen] = useState(false)

  // const embeddedWallet = wallets.find((wallet) => wallet.walletClientType === 'privy')
  // // Switch the embedded wallet to your target network
  // // Replace '80001' with your desired chain ID.
  // await embeddedWallet.switchChain(80001)

  const { injectedWallet, ui } = useStore()
  const networks = injectedWallet.getNetworksList()
  const selectedNetwork = injectedWallet.selectedNetwork

  useHideBodyScrollbar(isOpen)

  const handleSelectNetwork = (id: Network) => {
    // If wallet is active, only display the network as "selected" after connect.
    if (injectedWallet.isActive) {
      injectedWallet.switchNetwork(id)
    } else {
      // If not active, update the selector instantly
      const network = injectedWallet.setSelectedNetwork(id)
      if (!network) {
        injectedWallet.setSelectedNetwork(injectedWallet.defaultChainId)
        return console.debug('Selected network not found in chains configuration')
      }
    }
  }

  return (
    <>
      <Button
        onClick={() => {
          setIsMobileOpen(true)
        }}
        css={{
          padding: '6px 12px',
          background: selectedNetwork?.id ? symbolGradientMap[selectedNetwork.id] : '$gray400',
          borderRadius: '50%',
          '&:hover': {
            filter: 'brightness(1.1)'
          }
        }}
      >
        <Icon
          icon={selectedNetwork?.id ? tokenToIconMap[selectedNetwork.id] : 'Add'}
          iconSize={18}
          css={{
            '& .fill': {
              fill: getPolygonNetworks().includes(selectedNetwork!.id) ? '$gray900' : undefined
            }
          }}
        />
      </Button>

      <NetworkSelectorDialog
        isOpen={isMobileOpen}
        onIgnore={() => setIsMobileOpen(false)}
        onClick={(id) => {
          handleSelectNetwork(id)
          setIsMobileOpen(false)
        }}
        networks={networks}
      />
    </>
  )
}

export const NetworkSelector = observer(_NetworkSelector)
